import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import { DartsGameState, ISetGamePayload } from "./DartsGame.types";
import { DartsGameType } from "../../common/types/DartsGameTypes";
import { DartsGameStatus } from "../../common/types/DartsGameStatuses";
import { DartsGame } from "../../pages/Darts/EventManager/DartsEventManager.types";
import { IdName } from "../../common/types/IdName";
import { DARTS_SCORING } from "../../common/routes";

const initialState: DartsGameState = {
    game: {} as IdName,
    tournamen: {} as IdName,
    players: [] as IdName[],
    location: '',
    status: DartsGameStatus.Undefined,
    type: DartsGameType.STANDALONE,
    date: '',
    scores: [],
    isLoading: true,
    isReadonly: false,
    isShowWalkoverModal: false,
    isGameRunningLoader: false,
}

export const setGame = createAsyncThunk<void, ISetGamePayload>(
    'handler/setGame',
    async (payload: ISetGamePayload, {dispatch}) => {
        const { game, navigate } = payload
        dispatch(setDartsGame(game));
        const typeName = DartsGameType[game.type].toLowerCase();
        return navigate(`${DARTS_SCORING}/${typeName}/${game.id}`);
    }
);

export const DartsGameSlice = createSlice({
    name: 'DartsGameSlice',
    reducers: {
        setDartsGame: (state, action: PayloadAction<DartsGame>) => {
            state.game = action.payload;
            state.isLoading = false;
        },
        setDartsGameStatus: (state, action: PayloadAction<DartsGameStatus>) => {
            state.status = action.payload;
        },
        setGameRunningLoader: (state, action: PayloadAction<boolean>) => {
            state.isGameRunningLoader = action.payload;
        },
        setWalkoverModal: (state, action: PayloadAction<boolean>) => {
            state.isShowWalkoverModal = action.payload;
        },
        clearGame: (state) => {
            state.status = DartsGameStatus.Undefined;
        },
    },
    initialState
})
export const {
    setDartsGameStatus,
    setDartsGame,
    setGameRunningLoader,
    setWalkoverModal,
    clearGame
} = DartsGameSlice.actions;

export default DartsGameSlice.reducer;
